export default __webpack_public_path__ + "static/news27-11382c03cb14c4f0e13cae21f290031d.png";